// react, react-redux, redux-form
import React from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";

// styling
import "./SelectedProperty.scss";

const SelectedProperty = (props) => {
  const {formData, formName} = props;
  if (!formData) {
    return (
      <div className="selectedProperty">
        <div className='selectedProperty-tile'>
          <div className="selectedProperty-tile-content">
              <p className="selectedProperty-tile-content-heading">This {formName.replace("Form", "")} application relates to:</p>
              <div className="selectedProperty-tile-content-description">
                <div className="hero-loading-spin"></div>
              </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="selectedProperty">
        <div className='selectedProperty-tile'>
          <div className="selectedProperty-tile-content">
              <p className="selectedProperty-tile-content-heading">This {formName.replace("Form", "")} application relates to:</p>
              <div className="selectedProperty-tile-content-description">
                {formData.placeObjectName && (<p><span>Place or Object: </span>{formData.placeObjectName}</p>)}
                {formData.vhrNumber && (<p><span>VHR Number: </span>{formData.vhrNumber}</p>)}
                {(formData.address && formData.address.country) && (<p><span>Address: </span>{formData.address.unitNo} {formData.address.unitNo && (' / ')} {formData.address.streetNo} {formData.address.streetName}, {formData.address.suburb} {formData.address.state} {formData.address.postcode}</p>)}
              </div>
          </div>
        </div>
      </div>
    );
  }
};

const mapStateToProps = (state, formName) => {
  return {
    formData: (state.form[formName.form]) ? state.form[formName.form].values : {}
  };
};

const form = reduxForm({
  destroyOnUnmount: false, //        <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
});

export default connect(mapStateToProps)((form)(SelectedProperty));



    

